import { render } from "./AddJourneyPage.vue?vue&type=template&id=66c274e3&scoped=true"
import script from "./AddJourneyPage.vue?vue&type=script&lang=js"
export * from "./AddJourneyPage.vue?vue&type=script&lang=js"

import "./AddJourneyPage.vue?vue&type=style&index=0&id=66c274e3&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c274e3"]])

export default __exports__